import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent } from '@/components/ui/card';
import { Home, FileCheck, AlertCircle, Building } from 'lucide-react';

const HousingGuide = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate('/knowledge-base/documentation')}
          className="text-primary hover:text-primary/80 transition-colors mb-8 flex items-center"
        >
          ← Back to Documentation
        </button>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-4">
            Housing Documentation Guide
          </h1>
          <p className="text-muted-foreground">
            Complete guide to preparing and submitting housing documentation for your residence permit application.
          </p>
        </div>

        <div className="space-y-8">
          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Home className="h-5 w-5 text-primary mr-2" />
                Rental Agreement Requirements
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Signed rental agreement (umowa najmu)
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Proof of registration (meldunek)
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Landlord's property ownership document
                </li>
                <li className="flex items-start">
                  <FileCheck className="h-5 w-5 text-primary mr-2 mt-0.5" />
                  Confirmation of rent payments
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <Building className="h-5 w-5 text-primary mr-2" />
                Property Ownership Documents
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Property deed or ownership certificate
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Land and mortgage register extract
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Property tax payment confirmation
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-border">
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                <AlertCircle className="h-5 w-5 text-primary mr-2" />
                Common Documentation Issues
              </h2>
              <ul className="space-y-3 text-muted-foreground">
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Unsigned or incomplete rental agreements
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Missing registration confirmation
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Expired documents
                </li>
                <li className="flex items-start">
                  <span className="text-primary mr-2">•</span>
                  Incorrect address information
                </li>
              </ul>
            </CardContent>
          </Card>

          <div className="bg-accent p-6 rounded-lg border border-border">
            <h2 className="text-xl font-semibold text-foreground mb-2">Need Help with Housing Documentation?</h2>
            <p className="text-muted-foreground mb-4">
              Our experts can review your housing documents and ensure they meet all requirements.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors"
            >
              Get Document Review
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HousingGuide; 